<template>
    <div class="file-info">
        <div>
            <div class="title">{{$t('file.apiIntroduce')}}</div>
            <div style="white-space:pre-wrap;">{{this.$store.state.description}}</div>
        </div>
        <div>
            <div class="title">URL</div>
            <div v-if="this.$store.state.vType === '2'">{{this.locationUrl +'/rest/api/v3' + enameUrl}}</div>
            <div v-else >{{this.locationUrl +'/rest/api'}}</div>
        </div>
        <div>
            <div v-if="this.$store.state.vType === '2'">
                <div class="title">{{$t('public.publicRequestParam')}}</div>
                <el-table :data="CommonTableData1" border style="width: 100%">
                    <template v-for="(item,index) in commonHeader" >
                        <el-table-column  :key="index" :prop="item.prop" :label="item.label"  align="center">
                            <template scope="scope">
                                <span v-html="scope.row[item.prop]"></span>
                            </template>
                        </el-table-column>
                    </template>  
                </el-table>
            </div>
            <div v-else>
                <div class="title">{{$t('public.publicRequestParam')}}</div>
                <el-table :data="CommonTableData" border style="width: 100%">
                    <template v-for="(item,index) in commonHeader" >
                        <el-table-column  :key="index" :prop="item.prop" :label="item.label"  align="center">
                            <template scope="scope">
                                <span v-html="scope.row[item.prop]"></span>
                            </template>
                        </el-table-column>
                    </template>  
                </el-table>
            </div>
        <div> 
        <div>
            <div class="title">{{$t('public.workRequestParam')}}</div>
                <el-table :data="tableData" border style="width: 100%" row-key="id" :tree-props="{children: 'childs'}" :load="load" default-expand-all >
                    <template v-for="(item, index) in requestHeadArr" >
                        <el-table-column :key="index" :prop="item.prop" :label="item.label"  align="center">
                            <template scope="scope">
                                <span v-if="item.prop === 'isRequired'">
                                    {{scope.row[item.prop] | transferValue(that)}}
                                </span>
                                <span v-else>{{scope.row[item.prop]}}</span>
                            </template>
                        </el-table-column>
                    </template>  
                </el-table>
            </div>
        <div>  
        <div>
            <div class="title">{{$t('public.requestExample')}}</div>
                    <div style="margin-bottom:20px">{{$t('public.example') + 1}}</div>
                    <template >
                        <div class="wrapper">
                            <textarea id="textareaContent" class="textareaStyle"  readonly="readonly">
                                {{this.$store.state.requestBodySample}}
                            </textarea>
                            <i @click="copyText('textareaContent')" class="el-icon-copy-document copyIcon"></i>
                        </div>
                    </template>  
                <!-- <div v-show="isRealTimeData">
                    <div style="margin-bottom:20px" >示例2</div>
                    <template>
                        <div class="wrapper">
                            <textarea id="textareaContentTwo" class="textareaStyle"  readonly="readonly">
                                {{$store.state.requestBodySample2}}
                            </textarea>
                            <i @click="copyText('textareaContentTwo')" class="el-icon-copy-document copyIcon"></i>
                        </div>
                    </template>  
                </div> -->
            </div>
        </div>   
        <div>
            <div class="title">{{$t('public.respondParam')}}</div>
                <div style="margin-bottom:20px">{{$t('public.respondCode')}}：200</div>
                <el-table :data="backTableData" border style="width: 100%" row-key="id" :tree-props="{children: 'childs'}" :load="load" default-expand-all>
                    <template v-for="(item,index) in BackHeadArr" >
                        <el-table-column :key="index" :prop="item.prop" :label="item.label"  align="center">
                            <template scope="scope">
                                <span v-if="item.prop === 'isRequired'">
                                    {{scope.row[item.prop] | transferValue(that)}}
                                </span>
                                <span v-else>{{scope.row[item.prop]}}</span>
                            </template>
                        </el-table-column>
                    </template>  
                </el-table>
            </div>
        </div>  
        <div>
            <div class="title">{{$t('public.respondExample')}}</div>
                <div style="margin-bottom:20px">{{$t('public.example') + 1}}</div>
                <template >
                    <div class="wrapper">
                        <textarea id="backTextareaContent" class="textareaStyle"  readonly="readonly">
                            {{this.$store.state.responseBodySample}}
                        </textarea>
                        <i @click="copyText('backTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                    </div>
                </template> 
                <div v-show="isRealTimeData">
                    <div style="margin-bottom:20px">{{$t('public.callBackRespondExample')}}</div>
                    <template >
                        <div class="wrapper">
                            <textarea id="callBackTextareaContent" class="textareaStyle"  readonly="readonly">
                                {{this.$store.state.callbackurlResponseBodySample}}
                            </textarea>
                            <i @click="copyText('callBackTextareaContent')" class="el-icon-copy-document copyIcon"></i>
                        </div>
                    </template> 
                </div> 
            </div>
        </div>        
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        data() {
            var locationUrl = location.origin;
            return {
                that: this,
                CommonTableData1:[
                    {params:"method",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.apiName')},
                    {params:"appKey",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe1')},
                    {params:"timestamp",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe2')},
                    {params:"version",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.apiProtocol')},
                    {params:"sign",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe3') + "<a class='urlStyle' href='http://help.dataserver.cn/@jmp6y596r4/APIpeizhi.html' target='_blank'>"+ this.$t('file.clickEnter') +"</a>"}
                ],
                CommonTableData:[
                    {params:"method",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.apiName')},
                    {params:"appKey",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe1')},
                    {params:"timestamp",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe2')},
                    {params:"version",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.apiProtocol')},
                    {params:"sign",dataType:"String",mandatory:this.$t('public.yes'),describe:this.$t('file.describe3') + "<a class='urlStyle' href='http://help.dataserver.cn/@9421315rgb/APIpeizhi.html' target='_blank'>"+ this.$t('file.clickEnter') +"</a>"}
                ],
                commonHeader:[{label:this.$t('public.param') , prop : 'params'},{label:this.$t('public.dataType') , prop : 'dataType'},{label:this.$t('public.require') , prop : 'mandatory'},{label:this.$t('public.describe') , prop : 'describe'}],
                requestHeadArr:[
                    {label:this.$t('public.param') , prop : 'name'},
                    {label:this.$t('public.dataType') , prop : 'dataType'},
                    {label:this.$t('public.require') , prop : 'isRequired'},
                    {label:this.$t('public.describe') , prop : 'parameterDescription'}
　　　　　　     ],
                BackHeadArr:[
                    {label:this.$t('public.param') , prop : 'name'},
                    {label:this.$t('public.dataType') , prop : 'dataType'},
                    {label:this.$t('public.describe') , prop : 'parameterDescription'}
　　　　　　     ],
                locationUrl:locationUrl,
            }   
        },
        computed: {
            ...mapState(['isRealTimeData']),
            tableData() {
                return this.$store.state.fileRequestParams;
            },
            backTableData() {
                return this.$store.state.fileResponseParams;
            },
            enameUrl() {
                return this.isUplodEname(this.$store.state.ename) ? '/file' : '' 
            }
        },
        watch: {
            "$store.state.method"(v) {
                this.CommonTableData[0].describe = this.$t('file.apiName') + '，' + this.$t('public.example1') + '：' + v;
            },
            "$store.state.version"(v) {
                // this.CommonTableData[3].describe = 'API 协议版本，默认值：' + v;
                this.CommonTableData[3].describe = this.$t('file.apiProtocol') + '，' + this.$t('public.defaultValue') + '：' + v;
            },
            "$store.state.responseBodySample" (){
                document.getElementById('textareaContent').scrollTop = 0;
                document.getElementById('backTextareaContent').scrollTop = 0;
            }

        },
        created() {
            this.CommonTableData[0].describe = this.$t('file.apiName') + '，' + this.$t('public.example1') + '：' + this.$store.state.method;
            this.CommonTableData[3].describe = this.$t('file.apiProtocol') + '，' + this.$t('public.defaultValue') + '：' + this.$store.state.version;
        },
        methods: {
            load(tree, treeNode, resolve) {
                setTimeout(() => {
                    resolve(this.backTableData.childs)
                    }, 1000)
            },
            copyText(id) {
                document.getElementById(id).select();
                document.execCommand("copy");
                 this.$message({
                    message: this.$t('public.copySuccess'),
                    duration: 1500,
                    showClose: false,
                    type: 'success',
                    center:true
                })
            },
            isUplodEname(ename) {
                var enameArr = ['addIots','deleteDevices','addDevices','recoverIots'];
                return enameArr.indexOf(ename) > -1
            }
        },
        filters: {
            transferValue(value, that) {
                return +value === 1 ? that.$t('public.yes') : that.$t('public.no')
            }
        },
    }
</script>
<style lang="less" scoped>
    .file-info {
        font-size: 14px;
        padding: 0px 20px;
        padding-top: 61px;
        height:calc(100vh - 61px);
        overflow-y: scroll;

        .title {
            font-size: 18px;
            font-weight: bold;
            padding: 20px 0;
        }
        /deep/ .urlStyle {
            color: #409EFF;
        }
        .wrapper{
            position: relative;
            .copyIcon{
                position: absolute;
                top: 20px;right: 30px;
                font-size: 18px;
            }
            .copyIcon:hover{
                color: #409EFF;
            }
        }
        /deep/.textareaStyle{
            width:100%;
            height:200px;
            line-height:22px;
            font-size:14px;
            font-family:Arial;
            margin-bottom: 20px;
            border-color: rgba(118, 118, 118, 0.3);
            outline:none;
            background: rgba(239, 239, 239, 0.3);
            color: rgb(94, 93, 93);
        }
    }
    .file-info::-webkit-scrollbar {
        display: none;
    }

</style>
<style>
    .el-message {
        min-width: 280px !important;
    }
</style>